<template>
    <v-app>
        <v-dialog
            v-model="$store.getters['ActivateAudienceStore/getModalStatus']"
            persistent
            fullscreen
            hide-overlay
            transition="slide-x-reverse-transition"
            scrollable
            :content-class="isMobile"
        >
            <v-card tile>
                <v-toolbar
                    flat
                    dark
                    color="primary"
                >
                    <v-toolbar-title>{{ $store.getters['ActivateAudienceStore/getDescription'] }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            icon
                            dark
                            @click="$store.dispatch('ActivateAudienceStore/closeModal')"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <div class="card createActivation">
                        <div class="card-body pt-0">

                            <ActivationStepper></ActivationStepper>

                            <ActivationLimits v-if="step === 1" ref="component_step_1"></ActivationLimits>
                            <ActivationEndpoints :step=2 v-if="step === 2" ref="component_step_2"></ActivationEndpoints>
                            <ActivationProperties :step=3 v-if="step === 3" ref="component_step_3"></ActivationProperties>
                            <ActivationDataStreams :step=4 v-if="step === 4" ref="component_step_4"></ActivationDataStreams>
                            <ActivationSummary v-if="step === 5" ref="component_step_5"></ActivationSummary>
                            <ActivationCompleted v-if="step === 6" ref="component_step_6"></ActivationCompleted>

                            <hr>
                            <div class="row">
                                <div class="col-1 text-left" v-if="step === 6">
                                    <button @click="$store.dispatch('ActivateAudienceStore/closeModal')" class="btn btn-danger mx-1">Close</button>
                                </div>
                                <div class="col-1 text-left" v-if="step !== 6">
                                    <button @click="$store.dispatch('ActivateAudienceStore/closeModal')" class="btn btn-danger mx-1">Cancel</button>
                                </div>
                                <div class="col-1 text-right" v-if="step > 1 && step !== 6">
                                    <button @click.prevent="changeStep('decrease')" class="btn btn-warning mx-1">Back</button>
                                </div>
                                <div class="col-2 text-right" v-if="step < 5" :class="(step > 1) ? 'offset-8' : 'offset-9'">
                                    <button @click.prevent="changeStep('increase')" class="btn btn-success mx-1">Next</button>
                                </div>
                                <div class="col-2 offset-8 text-right" v-if="step === 5">
                                    <button @click.prevent="submitData" :disabled="submitted" class="btn btn-success mx-1">
                                        <v-progress-circular
                                            v-if="submitted"
                                            :width="2"
                                            :size="20"
                                            indeterminate
                                            color="#ffffff"
                                            class="mr-2"
                                        ></v-progress-circular>
                                        {{ create_button_text }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import Modal from '../Modal'
import api from "../../api/analyses/activations";
import mixins from "../../mixin";
import ActivationStepper from "./partials/activation/ActivationStepper";
import ActivationLimits from "./partials/activation/ActivationLimits.vue";
import ActivationEndpoints from "./partials/activation/ActivationEndpoints.vue";
import ActivationProperties from "./partials/activation/ActivationProperties.vue";
import ActivationDataStreams from "./partials/activation/ActivationDataStreams.vue";
import ActivationSummary from "./partials/activation/ActivationSummary.vue";
import ActivationCompleted from "./partials/activation/ActivationCompleted.vue";
export default {
    name: "ActivateAudienceItem",
    mixins: [mixins],
    components: {
        ActivationCompleted,
        ActivationSummary,
        ActivationDataStreams,
        ActivationProperties,
        ActivationEndpoints,
        ActivationLimits,
        ActivationStepper,
        Modal
    },
    data: () => ({
        submitted: false,
    }),
    methods: {
        submitData() {
            this.submitted = true
            this.activate()
        },
        async activate() {
            await api.activateActivation({
                audience_id: this.$store.getters['ActivateAudienceStore/getAudienceId'],
                description: this.$store.getters['ActivateAudienceStore/getDescription'],
                freq_limit: this.$store.getters['ActivateAudienceStore/getLimitByFrequencyStatus'],
                freq_min: this.$store.getters['ActivateAudienceStore/getFrequencyRange'][0],
                freq_max: this.$store.getters['ActivateAudienceStore/getFrequencyRange'][1],
                freq_total: this.$store.getters['ActivateAudienceStore/getLimitsTotal'],
                distance_limit: this.$store.getters['ActivateAudienceStore/getLimitByDistanceStatus'],
                distance: this.$store.getters['ActivateAudienceStore/getDistanceAnalysesLimit'],
                limit: this.$store.getters['ActivateAudienceStore/getLimitByFrequencyStatus'] ? this.$store.getters['ActivateAudienceStore/getLimitsTotal'] : this.$store.getters['ActivateAudienceStore/getAudience'],
                price: this.$store.getters['ActivateAudienceStore/getPrice'],
                inputs: this.$store.getters['ActivateAudienceStore/getActivationPartner'].inputs,
                audience_inputs: this.$store.getters['ActivateAudienceStore/getAudienceInputs'],
                partner_name: this.$store.getters['ActivateAudienceStore/getActivationPartner'].name,
                pricing_model: this.$store.getters['ActivateAudienceStore/getPricingModel'],
                compression: this.$store.getters['ActivateAudienceStore/getAudienceCompressionType'],
                notification: this.$store.getters['ActivateAudienceStore/getNotificationPreference'],
                credentials: this.$store.getters['ActivateAudienceStore/getAudienceServiceAccount'],
                datastreams: this.$store.getters['ActivateAudienceStore/getDataStreamsDeliveryData'],
            })
            .then(res => {
                this.changeStep("increase")
            })
            .catch(e => {
                this.$toast.open({
                    message: e.data.message,
                    type: "error",
                })
            })
        },
        close() {
            this.$store.commit('ActivateAudienceStore/RESET_STATE')
            this.$store.commit('ActivateAudienceStore/SET_MODAL', false)
        },
        changeStep(type) {
            if (type === 'increase') {
                this.$store.commit('ActivateAudienceStore/SET_STEP_STATUS', true)

                if ([1,2,3,4].includes(this.step)) {
                    this.$refs['component_step_' + this.step].validateForm()
                } else {
                    this.$store.dispatch('ActivateAudienceStore/increaseProcessStep')
                }
            }
            if (type === 'decrease') {
                this.$store.commit('ActivateAudienceStore/SET_STEP_STATUS', false)

                if (!this.$store.getters['ActivateAudienceStore/getActivationPartner'].is_data_streaming_allowed && this.$store.getters['ActivateAudienceStore/getCurrentStep'] === 5) {
                    this.$store.dispatch('ActivateAudienceStore/decreaseProcessStep')
                }

                if (this.$store.getters['ActivateAudienceStore/getActivationAnalyses'].includes(this.analyses.types.anonymized.toLowerCase()) && this.step === 5) {
                    this.$store.dispatch('ActivateAudienceStore/decreaseProcessStep')
                }

                this.$store.dispatch('ActivateAudienceStore/decreaseProcessStep')
            }
        },
    },
    computed: {
        step: function () {
            return this.$store.getters['ActivateAudienceStore/getCurrentStep']
        },
        create_button_text() {
            if (this.submitted) {
                return "Activating"
            } else {
                return "Activate"
            }
        },
    },
    mounted() {
        this.$store.dispatch('ActivateAudienceStore/getActivation')
        this.$store.commit('ActivateAudienceStore/SET_NOTIFICATION_PREFERENCE',
            this.$store.getters.getNotificationsPreferences.email.audiences_audience_activations
        )
    },
    watch: {
        //
    },
}
</script>

<style scoped>
.v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 32px;
    padding: 0 12px;
}

.v-dialog__content--active {
    z-index: 99998 !important;
}

.push-right {
    padding-left: 10% !important;
}
.theme--light.v-chip:not(.v-chip--active) {
  background: #f3f3f3;
}

.v-slider--horizontal {
    margin-left: 0 !important;
    margin-right: 0 !important;
}
</style>